module.exports = __webpack_public_path__ + "static/media/logo.49508723.png";